@if (collapsed) {
    <button
        #searchButton
        type="button"
        class="search-icon-button"
        [pTooltip]="'nav.chrome.search' | term"
        tooltipPosition="right"
        [attr.aria-label]="'nav.chrome.search' | term"
        (click)="resultsPanel.toggle($event)">
        <i class="pi pi-search"></i>
    </button>
} @else {
    <p-iconField iconPosition="left" class="nav-search-field">
        <p-inputIcon styleClass="pi pi-search" />
        <input
            #navInput
            pInputText
            type="text"
            class="w-full"
            autocomplete="off"
            [formControl]="searchControl"
            [placeholder]="'nav.chrome.search' | term"
            [attr.aria-label]="'nav.chrome.search' | term"
            (click)="showResults($event, navInput)"
            (input)="onType($event, navInput)"
            role="combobox"
            aria-autocomplete="list"
            [attr.aria-expanded]="isPanelOpen"
            [attr.aria-controls]="controlledListId"
            [attr.aria-activedescendant]="highlightedOptionId"
            (keydown.arrowdown)="moveHighlight(1, $event, navInput)"
            (keydown.arrowup)="moveHighlight(-1, $event, navInput)"
            (keydown.tab)="tabIntoResults($event)"
            (keydown.enter)="openHighlightedResult()"
            (keydown.escape)="resultsPanel.hide()" />
    </p-iconField>
}

<p-overlayPanel
    #resultsPanel
    appendTo="body"
    styleClass="global-search-panel"
    (onShow)="setPanelOpen(true); focusPanelInput()"
    (onHide)="setPanelOpen(false)">
    @if (collapsed) {
        <p-iconField iconPosition="left" class="panel-search-field">
            <p-inputIcon styleClass="pi pi-search" />
            <input
                #panelInput
                pInputText
                type="text"
                class="w-full"
                autocomplete="off"
                [formControl]="searchControl"
                [placeholder]="'nav.chrome.search' | term"
                [attr.aria-label]="'nav.chrome.search' | term"
                (input)="onType($event, panelInput)"
                role="combobox"
                aria-autocomplete="list"
                [attr.aria-expanded]="isPanelOpen"
                [attr.aria-controls]="controlledListId"
                [attr.aria-activedescendant]="highlightedOptionId"
                (keydown.arrowdown)="moveHighlight(1, $event, panelInput)"
                (keydown.arrowup)="moveHighlight(-1, $event, panelInput)"
                (keydown.tab)="tabIntoResults($event)"
                (keydown.enter)="openHighlightedResult()"
                (keydown.escape)="leaveResults($event)" />
        </p-iconField>
    }

    @if (state$ | async; as state) {
        @switch (state.status) {
            @case ("idle") {
                <p class="search-message" role="status">Search by ID or title</p>
            }
            @case ("searching") {
                <p class="search-message" role="status">Searching...</p>
            }
            @case ("noMatches") {
                <p class="search-message" role="status">No matching records</p>
            }
            @case ("failed") {
                <p class="search-message" role="status">Search is unavailable. Try again.</p>
            }
            @case ("found") {
                <div class="search-results" role="listbox" [id]="resultsListId">
                    @for (section of state.sections; track section.labelKey) {
                        <section
                            class="result-section"
                            role="group"
                            [attr.aria-label]="section.labelKey | term">
                            <h3
                                class="section-label"
                                aria-hidden="true"
                                >{{ section.labelKey | term }}</h3
                            >
                            @for (row of section.rows; track row.id) {
                                <a
                                    class="result-row"
                                    role="option"
                                    tabindex="0"
                                    [id]="row.optionId"
                                    [class.highlighted]="row.position === highlightedPosition"
                                    [attr.aria-selected]="row.position === highlightedPosition"
                                    [routerLink]="row.route"
                                    (mousemove)="highlight(row.position)"
                                    (focus)="highlight(row.position)"
                                    (keydown.arrowdown)="moveFocus(1, row.position, $event)"
                                    (keydown.arrowup)="moveFocus(-1, row.position, $event)"
                                    (keydown.tab)="tabFromRow($event, row.position)"
                                    (keydown.shift.tab)="shiftTabFromRow($event, row.position)"
                                    (keydown.escape)="leaveResults($event)"
                                    (click)="closeSearch()">
                                    <span
                                        class="result-id"
                                        >{{ row.publicId }}</span
                                    >
                                    <span
                                        class="result-title"
                                        >{{ row.title }}</span
                                    >
                                </a>
                            }
                        </section>
                    }
                </div>
            }
        }
    }
</p-overlayPanel>
